import {
  useContext,
} from 'react';
import PopupContext from 'common/contexts/PopupContext';

const usePopup = () => useContext(PopupContext);

export default usePopup;
